import { PageTitle } from "@client/components/round/PageTitle";
import { ComparisonsMatrix } from "@client/components/round/matrix/ComparisonsMatrix";
import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { StateContext } from "@client/pages/round/Round";
import userIsAdmin from "@client/utils/userIsAdmin";
import {
  getEffectiveTrack,
  hasTrackWithMatchingStatus,
  isUserFunder,
} from "@engine/round/accessors";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useContext } from "react";
import { Redirect } from "wouter";

export const ComparisonsPage = withErrorBoundary(() => {
  const context = useContext(StateContext);
  const { round, actingAsUserId: userId, mode } = context;
  const memberTrack = getEffectiveTrack(mode, round.members[userId]);
  const isAdmin = userIsAdmin(userId, context);
  const [showMembersOfOtherTracks, setShowMembersOfOtherTracks] =
    useLocalStorage("showMembersOfOtherTracks", false);
  const [showRowsWithNoData, setShowRowsWithNoData] = useLocalStorage(
    "showRowsWithNoData",
    false,
  );

  const accessiblePhases = [
    ...(isUserFunder(round, userId) ? ["2.initial-evaluations"] : []),
    "3.full-discussion",
    "4.evals-freeze",
    "5.complete",
  ];

  if (
    !isAdmin &&
    !hasTrackWithMatchingStatus(round, userId, mode, accessiblePhases)
  ) {
    return <Redirect to="/" />;
  }
  return (
    <div className="flex justify-center overflow-hidden">
      <div className="flex flex-col overflow-hidden px-8">
        <PageTitle title="Comparisons Matrix" />
        <div className="flex flex-row gap-2">
          {memberTrack !== "NO_TRACK" && (
            <label>
              Show members of other tracks
              <input
                type="checkbox"
                checked={showMembersOfOtherTracks}
                onChange={() =>
                  setShowMembersOfOtherTracks(!showMembersOfOtherTracks)
                }
              />
            </label>
          )}
          <label>
            Show rows with no data
            <input
              type="checkbox"
              checked={showRowsWithNoData}
              onChange={() => setShowRowsWithNoData(!showRowsWithNoData)}
            />
          </label>
        </div>
        <ComparisonsMatrix
          showMembersOfOtherTracks={showMembersOfOtherTracks}
          showRowsWithNoData={showRowsWithNoData}
        />
      </div>
    </div>
  );
});
